import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export interface Props {
        isFunnelStrategy?: boolean;
    }
    
export default /*@__PURE__*/_defineComponent({
  __name: 'TextWithTag',
  props: {
    isFunnelStrategy: { type: Boolean, default: false }
  },
  setup(__props: any) {

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h1", {
    class: _normalizeClass(['profile-text-with-tag__header', {'profile-text-with-tag__header--strategy': props.isFunnelStrategy}])
  }, [
    _renderSlot(_ctx.$slots, "text-before-tag"),
    _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
    _renderSlot(_ctx.$slots, "text-with-tag")
  ], 2))
}
}

})